<section class="settings-page">
  <header class="settings-heading">
    <span class="settings-icon"><img src="assets/media/svg/configuraciones.svg" alt="" width="48" height="48"></span>
    <div>
      <h1>Configuraciones</h1>
      <nav aria-label="Ruta de navegación"><a routerLink="/dashboard">Portal Defontana</a><span> / </span><a routerLink="/dashboard">Dashboard</a><span> / </span><span aria-current="page">Configuraciones</span></nav>
    </div>
  </header>
  <p class="settings-subtitle">Administra las preferencias y accesos de tu cuenta</p>
  <div class="settings-table-card" [attr.aria-busy]="appStateService.loading">
    <div class="settings-table-scroll">
      <table mat-table [dataSource]="appStateService.ListproductAccess && appStateService.ListproductAccess.productAccessControlList || []" aria-label="Preferencias y accesos de tu cuenta">
        <ng-container matColumnDef="col1">
          <th mat-header-cell *matHeaderCellDef>Configuración</th>
          <td mat-cell *matCellDef="let element">{{element.name}}</td>
        </ng-container>
        <ng-container matColumnDef="col2">
          <th mat-header-cell *matHeaderCellDef>Descripción</th>
          <td mat-cell *matCellDef="let element">{{element.description}}</td>
        </ng-container>
        <ng-container matColumnDef="col4">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element">
            <mat-slide-toggle [checked]="element.adminAccess" [disabled]="appStateService.loading" [aria-label]="'Activar o desactivar ' + element.name" (change)="slideChanged(element.productID, $event.checked)"></mat-slide-toggle>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr *matNoDataRow><td colspan="3" class="settings-empty" role="status">{{appStateService.loading ? 'Cargando configuraciones…' : 'No hay configuraciones disponibles.'}}</td></tr>
      </table>
    </div>
  </div>
</section>
